exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:1256px){#prev-next-container button[data-v-6c3d26f6]{width:100%}}@media screen and (max-width:766px){#prev-next-container button[data-v-6c3d26f6]{width:50%}}", ""]);

// exports
